import { styled } from '@mui/material';
import NameInputs from 'components/ProfileSetup/NameInputs';
import { useViewport } from 'contexts/viewport';
import { PageContext } from 'pages/ProfileSetup/PageProvider';
import { useContext } from 'react';
import { Box, Container, Copyright, Logo, Stack } from 'shell/components';

const Desktop = () => {
    const { device } = useViewport();
    const { loading, currentStep, errors, form, handleChange, handleComplete, PAGES } = useContext(PageContext);

    return (
        <Container device={device} sx={{ height: '100%', pb: 3 }}>
            <CenterBox>
                <Stack alignItems={'center'} spacing={2}>
                    <Logo device={'desktop'} />
                </Stack>
                {currentStep === PAGES.NAME && (
                    <NameInputs
                        loading={loading}
                        device={device}
                        isLastStep
                        form={form}
                        errors={errors}
                        handleChange={handleChange}
                        handleNext={() => handleComplete({ skip: true })}
                        handleComplete={handleComplete}
                        PAGES={PAGES}
                    />
                )}
            </CenterBox>
            <Copyright />
        </Container>
    );
};

const CenterBox = styled(Box)(({ theme }) => {
    return {
        paddingTop: theme.spacing(18),
        width: 'fit-content',
        height: '100%',
    };
});

export default Desktop;
